module.exports = __webpack_public_path__ + "static/media/delama_staley_lentz.43fba225.jpg";